import * as React from 'react';
import { Action, Dispatch } from 'redux';
import { toast } from 'react-toastify';

import { ToastComponent, ToastType, ToastOptions } from '@common/components';
import { contractService } from '@services/ContractService';

import { ContractPaymentConfirmationState } from './contract-payment-confirmation.reducer';

// We can use enums instead of type constants like in the example. This is a newer TS feature
export enum ContractPaymentConfirmationActionType {
  SendPaymentReceiptEmailFailure = 'SendPaymentReceiptEmailFailure',
  SendPaymentReceiptEmailStart = 'SendPaymentReceiptEmailStart',
  SendPaymentReceiptEmailSuccess = 'SendPaymentReceiptEmailSuccess',
  SetEmailAddresses = 'SetEmailAddresses'
}

// This is defining the action definition for certain actions on the page.
// There may be multiple types of these on a given page.
// All properties should be readonly.
interface ContractPaymentConfirmationAction extends Action {
  readonly type: ContractPaymentConfirmationActionType;
}

export interface SendPaymentReceiptEmailFailureAction extends ContractPaymentConfirmationAction {}
export interface SendPaymentReceiptEmailStartAction extends ContractPaymentConfirmationAction {}
export interface SendPaymentReceiptEmailSuccessAction extends ContractPaymentConfirmationAction {}

export interface SetEmailAddressesAction extends ContractPaymentConfirmationAction {
  readonly emailAddresses: string[];
}

// Actions for each action type declared here.
// They should all return an action object.
export function sendPaymentReceiptEmail(
  contractId: number,
  emailAddresses: string[],
  paymentDate: Date,
  creditCardLastFour?: string
) {
  return async (dispatch: Dispatch<ContractPaymentConfirmationState>) => {
    dispatch(sendPaymentReceiptEmailStart());
    try {
      if (emailAddresses && emailAddresses.length > 0) {
        await contractService.sendPaymentReceiptEmail(contractId, emailAddresses, paymentDate, creditCardLastFour);
      }
      return dispatch(sendPaymentReceiptEmailSuccess());
    } catch (e) {
      return dispatch(sendPaymentReceiptEmailFailure());
    }
  };
}

export function sendPaymentReceiptEmailFailure(): SendPaymentReceiptEmailFailureAction {
  toast.error(
    <ToastComponent type={ToastType.Error} message={'Network error, unable to activate contract'} />,
    ToastOptions.Error
  );
  return {
    type: ContractPaymentConfirmationActionType.SendPaymentReceiptEmailFailure
  };
}

export function sendPaymentReceiptEmailStart(): SendPaymentReceiptEmailStartAction {
  return {
    type: ContractPaymentConfirmationActionType.SendPaymentReceiptEmailStart
  };
}

export function sendPaymentReceiptEmailSuccess(): SendPaymentReceiptEmailSuccessAction {
  return {
    type: ContractPaymentConfirmationActionType.SendPaymentReceiptEmailSuccess
  };
}

export function setEmailAddresses(emailAddresses: string[]): SetEmailAddressesAction {
  return {
    type: ContractPaymentConfirmationActionType.SetEmailAddresses,
    emailAddresses: emailAddresses
  };
}



// WEBPACK FOOTER //
// ./src/contract/_components/contract-payment/_components/confirmation/contract-payment-confirmation.actions.tsx